<template>
	<div>
		<div class="container" id="container">
			<div v-title>订单信息</div>
			<!--<div class="title">订单信息</div>-->
			<div class="item-m">
					<div class="item-lable">店铺名:</div><p class="text">{{order.sitename}}</p>
			</div>
			<div class="item-m"><div class="item-lable">订单编号:</div>
				<p>{{order.ordercode}}</p>
			</div>
			<div class="good-box">
				<div class="item-m">
					<div class="item-lable">利润空间:</div><p>{{order.profit}}</p>
				</div>
				<div v-for="item in order.productinfo" :key="item.id">
					<div class="item-m">
						<div class="item-lable">产品名称:</div><p class="text">{{item.productname}}</p>
						</div>
					<div class="item-m">
						<div class="item-lable">产品规格:</div><p>{{item.productspec}}</p>
					</div>
					<div class="item-m">
						<div class="item-lable">产品图片:</div><p><img @click="showBig1(item.picurl)" v-if="item.picurl" style="width: 1.333333rem; height: 1.333333rem;" :src="'http://img.reflower.com.cn/'+ item.picurl"   ></p>
					</div>
				</div>
			</div>
			<div class="item-box">


				<div class="item-m">
					<div class="item-lable">收货时间:</div><p style="color: red;">{{order.receivedate}}</p>
				</div>
				<div class="item-m">
					<div class="item-lable">下单时间:</div><p>{{order.createdate}}</p>
				</div>
				<div class="item-m">
					<div class="item-lable">祝福卡:</div><p style="text-align: left;word-wrap: normal | break-word ;">{{order.orderbless}}</p>
				</div>
				<div class="item-demand">
					<div class="item-lable">订单留言:</div><p style="text-align: left;word-wrap: normal | break-word ;">{{order.orderdesc}}</p>
				</div>
			</div>
			<div class="user-info">
				<div class="user">
					<div class="item-lable">收花人:</div><p>{{order.receivername}}</p>
				</div>
				<div class="user">
					<div class="item-lable">收花人电话:</div><p v-if="order.receivermobile"><a style="text-decoration: none;" :href="'tel:' + order.receivermobile">{{order.receivermobile}}</a>&nbsp;<span style="color: red;">(联系收花人请用花点时间服务人员的口径)</span></p>
				</div>
				<div class="user">
					<div class="item-lable">订花人电话:</div><p v-if="order.usermobile"><a style="text-decoration: none;" :href="'tel:' + order.usermobile">{{order.usermobile}}</a>&nbsp;<span style="color: red;">(联系订花人请用花点时间服务人员的口径)</span></p>
				</div>
				<div class="user">
					<div class="item-lable">地址:</div><p>{{order.receiveraddress}}</p>
				</div>
			</div>
			<div class="img-container">
				<div class="img-box" id="imgboxid">
					<div class="img-item" v-for="(item,index) in imgArr">
						<span class="del-img" @click="delImg(index)">
							<img src="https://misc.reflower.com.cn/images/customer/delete.png" />
						</span>
						<img class="add-img" :src="item" @click="showBig(item)" />
					</div>
				</div>
				<input type='file' id="imgInp" @change="upimg($event)" name="multipartFiles" accept="image/*" style="display: none;" />
				<img id="blah0" v-if="imgArr.length<1" class="add-img" @click="checkipt()" width="100" src="https://misc.reflower.com.cn/images/customer/camera.png" alt="显示您上传的商品图片" />
			</div>
			<div class="btn-box">
				<div class="btn" @click="received" v-if="order.deliverystatus=='0'">确认收到</div>
				<div class="btn" @click="makeDone" v-if="order.deliverystatus=='0' || order.deliverystatus=='50' ">制作完成</div>
				<div class="btn" @click="reSendDada" v-if="order.deliverystatus=='500'">重新派送</div>
			</div>
		</div>
		<div class="explain-wrap" v-show="showExplain" @click="hideBig">
			<div class="content-boxb">
				<img v-if="transImg!=''" :src="transImg" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				order: {},
				orderCode: "",
				api: 'http://deliveryday.reflower.com.cn',
				//ce
				// api: 'http://delivery.ce.reflower.com.cn/erpcode',
				imgArr: [],
				showExplain: false,
				transImg: "",
				hasImg: false
			}
		},
		created() {
			this.orderCode = this.$route.query.ordercode;
			this.setCookie('ordercode', this.orderCode);
			this.getThirdDetail();

		},
		mounted() {
			let h = document.documentElement.clientHeight || document.body.clientHeight;
			let container = document.getElementById("container");
			container.style.height = h + 'px'
		},
		methods: {
			getThirdDetail: function() {
				this.http({
					method: 'get',
					url: this.api + '/deliverythird/getdetail?ordercode=' + this.orderCode
//					url: 'static/detail.json'
				}).then(res => {
					if(res.data.httpCode == 200) {
						this.order = res.data.data
						if(this.order.profit == "" || this.order.profit == null || this.order.profit == undefined) {
							this.order.profit = '0.00'
						}else{
							this.order.profit = Number(this.order.profit).toFixed(2)

						}


					} else {
						this.popUp(res.data.data.errermsg)
					}
				}).catch(err => {

				})
			},
			received: function() {
				this.http({
					method: 'get',
					url: this.api + '/deliverythird/make?ordercode=' + this.orderCode

				}).then(res => {
					if(res.data.httpCode == '200') {
						this.popUp("操作成功!")
						this.getThirdDetail();
					} else {
						this.popUp(res.data.data.errermsg)
					}
				})
			},
			makeDone: function() {
				if(this.hasImg) {
					this.http({
						method: 'get',
						url: this.api + '/deliverythird/finish?ordercode=' + this.orderCode,

					}).then(res => {
						if(res.data.httpCode == '200') {
							this.popUp("操作成功!")
							this.getThirdDetail();
						} else {
							this.popUp(res.data.data.errermsg)
						}
					})
				}else{
					this.popUp("请先上传制作完成鲜花的图片！")
				}

			},
			//重新派送
			reSendDada : function(){
				this.http({
						method: 'get',
						url: this.api + '/deliverythird/reSendDada?ordercode=' + this.orderCode,

					}).then(res => {
						if(res.data.httpCode == '200') {
							this.popUp("操作成功!")
							this.getThirdDetail();
						} else {
							this.popUp(res.data.data.errermsg)
						}
					})
			},

			//tost
			popUp: function(content) {
				layer.open({
					content: content,
					skin: 'msg',
					time: 2 //2秒后自动关闭
				});
			},
			//BIG
			showBig: function(item) {
				this.showExplain = true;
				this.transImg = item;
			},

			showBig1 : function(item){
				this.showExplain = true;
				this.transImg ='http://img.reflower.com.cn/' + item;

			},

			hideBig: function() {
				this.showExplain = false;
			},

			checkipt: function() {
				$('#imgInp').trigger("click");
			},

			//刪除圖片
			delImg: function(index) {
				console.log(2)
				this.imgArr.splice(index, 1)
			},

			upimg: function(event) {
				console.log(event.target.files)
				var _this = this;
				var imgurl =this.api + '/deliverythird/image/upload?ordercode='+ this.orderCode;
				var iamges = new Array();
				var file1 = event.target.files;
				for(var i = 0; i < file1.length; i++) {
					var file = file1[i];
					(function(file, i) {
						var reader = new FileReader();
						iamges[i] = new Image();
						reader.readAsDataURL(file);
						reader.onloadend = function(e) {
							var ace = this.result;
							iamges[i].src = ace;
							console.log(ace, 'ace')
						}
						let loStr = 'https://misc.reflower.com.cn/images/customer/uploading.png';
						_this.imgArr.splice(i, 0, loStr);
						iamges[i].onload = function() {
							var w = iamges[i].width;
							var h = iamges[i].height;
							var ratio, multiplier;
							if(w < 720 && h < 720) { //小于100K 的不压缩
								multiplier = 1;
								ratio = 0.8;
							} else {
								ratio = 1;
								if(w < 720 && h >= 720) {
									multiplier = 720 / h;
								} else if(w >= 720 && h < 720) {
									multiplier = 720 / w;
								} else {
									multiplier = 720 / Math.max(w, h);
									ratio = 0.8;
								}
							}
							var imageData = _this.compress(iamges[i], w * multiplier, h * multiplier, ratio);
							var formData = new FormData();
							formData.append("imageData", imageData);
							$.ajax({
								url: imgurl,
								type: 'POST',
								cache: false,
								data: formData,
								async: false,
								processData: false,
								contentType: false,
								dataType: "json",
								xhrFields: {
									withCredentials: true
								},
								crossDomain: true,
								success: function(msg) {
									if(msg.httpCode == 200) {
										var str = 'http://img.reflower.com.cn/' + msg.data;
										_this.hasImg = true;
										if(_this.imgArr.length == 1) {
											_this.imgArr.splice(i, 1);
											_this.imgArr.push(str);
										} else {
											return
										}
									} else {
										_this.popUp(msg.msg)
									}
								}
							});
						}
					})(file, i)

				}
			},
			compress: function(img, width, height, ratio) {
				var canvas, ctx, img64;
				canvas = document.createElement('canvas');
				canvas.width = width;
				canvas.height = height;
				ctx = canvas.getContext("2d");
				ctx.drawImage(img, 0, 0, width, height);
				img64 = canvas.toDataURL("image/jpeg", ratio);
				return img64;
			},

			setCookie: function(name, value) { //添加cookie
				var Days = 1;
				var exp = new Date();
				exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
				var cookie = name + "=" + escape(value) + ";path=/;domain=reflower.com.cn;expires=" + exp.toGMTString() + "";
				document.cookie = cookie;
			}
		}
	}
</script>

<style scoped>
	.container {
		font-size: 0.426666rem;
		font-family: Ping Fang;
		padding-top: 0.4rem;
		background-color: #FFFFFF;
		font-size: 0.346666rem;
	}

	.title {
		font-size: 0.48rem;
		font-weight: 500;
		height: 0.666666rem;
		line-height: 0.666666rem;
		padding: 0 0.4rem;
		margin-bottom: 0.266666rem;

	}
	.good-box{
		border-bottom: 0.266666rem solid #f3f5f8;
	}
	.item-m{
		display: flex;
		justify-content: space-between;
		text-align: left;
		padding: 0.2rem 0.4rem 0.2rem 0.4rem;
		border-bottom: 1px solid #F3F5F8;
	}
	.item-demand{
		display: flex;
		justify-content: space-between;
		text-align: left;
		padding: 0.2rem 0.4rem 0.2rem 0.4rem;
		border-bottom: 0.266666rem solid #F3F5F8;
	}
	.item-demand p{
		width: 7.5rem;
	}
	.item-m p{
		width: 7.5rem;
	}

	.item-lable{
		width: 2.5rem;
	}


	.item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 1.346666rem;
		border-bottom: 0.266666rem solid #F3f5f8;
		padding: 0 0.4rem;

	}

	.item span {
		display: inline-block;
		align-items: center;
	}

	.item-c {
		display: flex;
		justify-content: space-between;
		height: 0.8rem;
		line-height: 0.8rem;
		align-items: center;
		padding-bottom: 0.4rem;
		background-color: #FFFFFF;
		padding: 0 0.4rem;
		border-bottom: 1px solid #f3f5f8;
	}


	.item-c span:first-of-type {
		margin-right: 0.266666rem;
	}

	.item-c:last-of-type {
		margin-bottom: 0;
		/*border-bottom: 1px solid #999999;*/
	}

	.item-box {
		/*padding-bottom: 0.4rem;
		border-bottom: 1px solid #F3f5f8;*/
	}

	.user-info {
		/*margin-top: 0.266666rem;*/
		border-bottom: 0.266666rem solid #F3f5f8;
	}

	.user {
		display: flex;
		justify-content: space-between;
		min-height: 0.666666rem;
		padding: 0.2rem 0.4rem;
		border-bottom: 1px solid #F3F5F8;
		text-align: left;
		background-color: #FFFFFF;
	}
	.user p{
		width: 7.5rem;
	}


	.btn-box {
		display: flex;
		justify-content: space-around;
		align-items: center;
		height: 2rem;
		background-color: #FFFFFF;
		margin-bottom: 1rem;
	}

	.btn {
		width: 2.133333rem;
		background-color: #C4D703;
		border-radius: 0.133333rem;
		height: 0.8rem;
		line-height: 0.8rem;
		color: #FFFFFF;
	}

	.img-container {
		padding: 0.4rem 0.4rem;
		background-color: #FFFFFF;
	}
	.img-box{
	}
	.img-box .img-item {
		width: 1.6rem;
		height: 1.6rem;
		position: relative;
		margin-right: 0.32rem;
	}

	.img-box .img-item img {
		display: block;
		width: 1.6rem;
		height: 1.6rem;
	}

	.img-box .img-item .del-img {
		display: inline-block;
		height: 0.453333rem;
		height: 0.453333rem;
		position: absolute;
		right: -0.226666rem;
		top: -0.226666rem;
	}

	.img-box .img-item .del-img img {
		width: 0.453333rem;
		height: 0.453333rem;
	}

	.add-img {
		display: block;
		width: 1.6rem;
		height: 1.6rem;
	}

	.explain-wrap {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 1000;
	}

	.explain-wrap::before {
		content: '';
		z-index: 0;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: #000;
		opacity: 0.7;
	}

	.content-boxb {
		z-index: 3001;
		width: 8.8rem;
		/*height: 12.666666rem;*/
		border-radius: 0.106666rem;
		position: absolute;
		background-color: #fff;
		left: 50%;
		top: 50%;
		-webkit-transform: translate(-50%, -50%);
		-o-transform: translate(-50%, -50%);
		-moz-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}

	.content-boxb img {
		display: block;
		width: 100%;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/path/submenu/submenu.vue